module.exports = __webpack_public_path__ + "img/second_cloud.af631a46.png";